import {getIsStorageConsentGiven} from '@aboutyou/storage';

/**
 * `abTestsActivatedBeforeCookieConsent` holds the experiment keys of the features the user saw before accepting the cookie consent.
 * The experiment keys which got added here should be filtered out from the AB Tests which can be shown to the user in the current session.
 */
export const abTestsActivatedBeforeCookieConsent = new Set<string>();

export const rememberAbTestsActivatedBeforeCookieConsent = (
  experimentKey: string | undefined,
) => {
  if (
    experimentKey &&
    !getIsStorageConsentGiven() &&
    !abTestsActivatedBeforeCookieConsent.has(experimentKey)
  ) {
    abTestsActivatedBeforeCookieConsent.add(experimentKey);
  }
};
